import React, { useState } from "react";
import ProductsSidebar from "./ProductsSidebar";
import { FaBars } from "react-icons/fa";

const ProductsLayout = ({ 
  children, 
  products, 
  filters, 
  onFilter, 
  onReset,
  subcategories,
  onSubcategorySelect,
  selectedSubcategory
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="md:hidden mb-4 flex justify-between items-center">
        <h2 className="text-xl font-bold">Filter Products</h2>
        <button
          onClick={() => setSidebarOpen(true)}
          className="p-2 bg-gray-200 rounded-md"
        >
          <FaBars className="text-gray-700" />
        </button>
      </div>

      <div className="flex flex-col md:flex-row">
        <div
          className={`fixed inset-0 z-40 bg-white p-4 transform transition-transform md:relative md:translate-x-0 md:w-1/4 lg:w-1/5 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          } md:block overflow-y-auto`}
        >
          <ProductsSidebar
            onClose={() => setSidebarOpen(false)}
            filters={filters}
            onFilter={onFilter}
            onReset={onReset}
            subcategories={subcategories}
            onSubcategorySelect={onSubcategorySelect}
            selectedSubcategory={selectedSubcategory}
          />
        </div>

        {sidebarOpen && (
          <div
            className="fixed inset-0 z-30 bg-black bg-opacity-50 md:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <div className="w-full md:w-3/4 lg:w-4/5">{children}</div>
      </div>
    </div>
  );
};

export default ProductsLayout;